// Kartu Penerjun "Jawsel Air" — boarding pass vertikal gelap (sesuai mockup pilihan user), digambar di canvas agar tajam & bisa diekspor PNG story 9:16.
// Satu sumber gambar untuk layar & ekspor: gambarKartu(ctx, data) pada koordinat 0..KW × 0..KH (skala lewat ctx.scale).
import { gambarPesawat, gambarPenerjun, gayaTerjun } from "./pulau/pesawat";

export const KW = 360, KH = 664;            // ukuran dasar kartu (unit) — proporsi tinggi seperti mockup
const FONT = "'Plus Jakarta Sans', sans-serif";
const TEBAL = "'Outfit', 'Plus Jakarta Sans', sans-serif";          // huruf display geometris tebal (username, DJ, nilai) seperti mockup
const BIRU = "#0000CD", MERAH = "#d32f2f", KREM = "#efe9d8", ARANG = "#1a1c21", PUTIH = "#f6f5f0";
const f = (w, px) => `${w} ${px}px ${FONT}`;
const g = (w, px) => `${w} ${px}px ${TEBAL}`;
const SOBEK = 440, KEPALA = 72;

export async function siapkanFont() {
  if (!document.fonts) return;
  await Promise.all([...[800, 700, 600].map(w => document.fonts.load(f(w, 20))), ...[900, 800, 700].map(w => document.fonts.load(g(w, 20)))].map(p => p.catch(() => {})));
}

function teks(ctx, t, x, y, font, warna, align = "left", spasi = 0) {
  ctx.font = font; ctx.fillStyle = warna; ctx.textAlign = align; ctx.textBaseline = "alphabetic";
  if ("letterSpacing" in ctx) ctx.letterSpacing = `${spasi}px`;
  ctx.fillText(t, x, y);
  if ("letterSpacing" in ctx) ctx.letterSpacing = "0px";
}
function teksMuat(ctx, t, x, y, w, px, berat, warna, spasi = -0.5) {
  let ukuran = px; ctx.font = g(berat, ukuran);
  while (ctx.measureText(t).width > w && ukuran > 12) { ukuran -= 1; ctx.font = g(berat, ukuran); }
  teks(ctx, t, x, y, g(berat, ukuran), warna, "left", spasi);
}
function teksLengkung(ctx, t, cx, cy, r, mulai, font, warna) {
  ctx.save(); ctx.font = font; ctx.fillStyle = warna; ctx.textAlign = "center"; ctx.textBaseline = "middle";
  const total = [...t].reduce((a, c) => a + ctx.measureText(c).width, 0), sudut = total / r;
  let a = mulai - sudut / 2;
  for (const c of t) { const w = ctx.measureText(c).width, da = w / r; ctx.save(); ctx.translate(cx + Math.cos(a + da / 2) * r, cy + Math.sin(a + da / 2) * r); ctx.rotate(a + da / 2 + Math.PI / 2); ctx.fillText(c, 0, 0); ctx.restore(); a += da; }
  ctx.restore();
}
function barcode(ctx, kode, x, y, w, h, warna) {
  let seed = 0; for (const c of kode) seed = (seed * 31 + c.charCodeAt(0)) >>> 0;
  const n = 52, unit = w / (n * 1.7); let px = x;
  ctx.fillStyle = warna;
  for (let i = 0; i < n; i++) { seed = (seed * 1103515245 + 12345) >>> 0; const tebal = 1 + (seed >> 16) % 3; ctx.fillRect(px, y, tebal * unit, h); px += (tebal + 1 + ((seed >> 8) % 2)) * unit; }
}

// Cap imigrasi bulat merah (mendarat) menyilang garis sobekan, atau stempel BOARDING tipis (belum terbang)
function cap(ctx, d, cx, cy) {
  ctx.save(); ctx.translate(cx, cy); ctx.rotate(-0.3);
  if (d.mendarat) {
    ctx.globalAlpha = 0.9; ctx.strokeStyle = MERAH; ctx.fillStyle = MERAH; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.arc(0, 0, 64, 0, Math.PI * 2); ctx.stroke(); ctx.lineWidth = 1.2; ctx.beginPath(); ctx.arc(0, 0, 57, 0, Math.PI * 2); ctx.stroke();
    teksLengkung(ctx, "IMIGRASI • DISTRICT JAWSEL •", 0, 0, 48, -Math.PI / 2, f(800, 9), MERAH);
    teks(ctx, "MENDARAT", 0, -4, g(900, 15), MERAH, "center", 0.8);
    teks(ctx, `${d.berangkat_wib} WIB`, 0, 13, g(900, 16), MERAH, "center");
    teks(ctx, d.tanggal_wib || "", 0, 28, f(700, 8.5), MERAH, "center", 1);
  } else {
    ctx.globalAlpha = 0.75; ctx.strokeStyle = "#5b86e8"; ctx.lineWidth = 1.8; ctx.beginPath(); ctx.roundRect(-54, -16, 108, 32, 6); ctx.stroke();
    teks(ctx, "BOARDING", 0, 6, g(900, 16), "#5b86e8", "center", 2.5);
  }
  ctx.restore();
}

export function gambarKartu(ctx, d) {
  const sub = "rgba(246,245,240,.55)", garis = "rgba(255,255,255,.1)";
  const bentuk = new Path2D(); bentuk.roundRect(0, 0, KW, KH, 22); for (const x of [0, KW]) { bentuk.moveTo(x + 13, SOBEK); bentuk.arc(x, SOBEK, 13, 0, Math.PI * 2); }
  ctx.save();
  ctx.shadowColor = "rgba(0,0,0,.35)"; ctx.shadowBlur = 30; ctx.shadowOffsetY = 14; ctx.fillStyle = ARANG; ctx.fill(bentuk, "evenodd"); ctx.shadowColor = "transparent";
  ctx.clip(bentuk, "evenodd");
  ctx.fillStyle = KREM; ctx.fillRect(0, SOBEK, KW, KH - SOBEK);                       // sobekan krem
  ctx.fillStyle = BIRU; ctx.fillRect(0, 0, KW, KEPALA);                               // kepala biru
  // kepala: JAWSEL AIR miring · jet di tengah-kanan · KARTU / PENERJUN
  ctx.save(); ctx.font = g(900, 27); ctx.fillStyle = "#fff"; ctx.textAlign = "left"; ctx.translate(22, 46); ctx.transform(1, 0, -0.2, 1, 0, 0); if ("letterSpacing" in ctx) ctx.letterSpacing = "-0.2px"; ctx.fillText("JAWSEL AIR", 0, 0); ctx.restore();
  ctx.save(); ctx.translate(KW - 98, 37); ctx.scale(0.3, 0.3); gambarPesawat(ctx, 0, 0, 0, 1, true); ctx.restore();
  teks(ctx, "KARTU", KW - 22, 34, g(800, 9.5), "rgba(255,255,255,.92)", "right", 1.4);
  teks(ctx, "PENERJUN", KW - 22, 47, g(800, 9.5), "rgba(255,255,255,.92)", "right", 1.4);
  // username besar
  teksMuat(ctx, `@${d.username}`, 22, 142, KW - 44, 42, 800, PUTIH, -1.2);
  // rute
  const yR = 182;
  teks(ctx, "INSTAGRAM", 22, yR, g(700, 10.5), PUTIH, "left", 1.2);
  teks(ctx, "DISTRICT JAWSEL", KW - 22, yR, g(700, 10.5), PUTIH, "right", 1.2);
  ctx.save(); ctx.strokeStyle = sub; ctx.lineWidth = 1.2; ctx.setLineDash([3, 4]); ctx.beginPath(); ctx.moveTo(102, yR - 4); ctx.lineTo(KW / 2 - 16, yR - 4); ctx.moveTo(KW / 2 + 16, yR - 4); ctx.lineTo(KW - 140, yR - 4); ctx.stroke(); ctx.restore();
  ctx.save(); ctx.translate(KW / 2, yR - 5); ctx.scale(0.18, 0.18); gambarPesawat(ctx, 0, 0, 0, 1, true); ctx.restore();
  // grid 2 kolom × 3 baris dengan garis pemisah tipis
  const gTop = yR + 22, BARIS_H = 62, kolom = KW / 2;
  ctx.fillStyle = garis; ctx.fillRect(22, gTop, KW - 44, 1); ctx.fillRect(kolom, gTop, 1, BARIS_H * 3);
  for (let r = 1; r < 3; r++) ctx.fillRect(22, gTop + r * BARIS_H, KW - 44, 1);
  const isi = [["PENERBANGAN", d.nomor || "—"], ["KURSI", d.kursi || "—"], ["BERANGKAT", d.berangkat_wib ? `${d.berangkat_wib} WIB` : "—"], ["GAYA TERJUN", gayaTerjun(d.username).toUpperCase()],
               ["PAYUNG", d.nama_warna ? d.nama_warna.toUpperCase() : "KEJUTAN"], ["BARENG", `${d.bareng || 0} PENERJUN`]];
  isi.forEach(([l, v], i) => {
    const x = 22 + (i % 2) * kolom, y = gTop + Math.floor(i / 2) * BARIS_H;
    teks(ctx, l, x, y + 20, f(700, 8.5), sub, "left", 1.2);
    if (l === "PAYUNG") { ctx.fillStyle = d.warna || BIRU; ctx.beginPath(); ctx.arc(x + 7, y + 41, 6.5, 0, Math.PI * 2); ctx.fill(); teks(ctx, v, x + 20, y + 47, g(800, 19), PUTIH, "left", -0.2); }
    else teks(ctx, v, x, y + 47, g(800, 19), PUTIH, "left", -0.2);
  });
  // penerjun berpayung warna dia, di kanan baris 1–2
  ctx.save(); ctx.translate(KW - 50, gTop + 48); ctx.scale(1.45, 1.45); gambarPenerjun(ctx, 0, 0, 0.6, d.warna || BIRU, "", 1); ctx.restore();
  // paspor: lompatan ke-N + cap kecil pendaratan sebelumnya (sekali per postingan → bisa terjun lagi)
  if ((d.terjun_ke || 1) > 1) {
    const yC = SOBEK - 22;
    teks(ctx, `TERJUN KE-${d.terjun_ke}`, 22, gTop + BARIS_H * 3 + 16, f(700, 8.5), sub, "left", 1.2);
    (d.riwayat || []).slice(0, 5).forEach((r, i) => {
      ctx.save(); ctx.translate(40 + i * 38, yC); ctx.rotate(-0.3 + i * 0.12); ctx.globalAlpha = 0.85; ctx.strokeStyle = MERAH; ctx.lineWidth = 1.6;
      ctx.beginPath(); ctx.arc(0, 0, 15, 0, Math.PI * 2); ctx.stroke(); ctx.lineWidth = 0.8; ctx.beginPath(); ctx.arc(0, 0, 12.5, 0, Math.PI * 2); ctx.stroke();
      teks(ctx, (r.tanggal_wib || "").slice(0, 6), 0, -1, g(800, 5.5), MERAH, "center"); teks(ctx, r.berangkat_wib || "", 0, 7, g(800, 6.5), MERAH, "center");
      ctx.restore();
    });
  }
  // garis sobekan
  ctx.save(); ctx.strokeStyle = "rgba(255,255,255,.35)"; ctx.setLineDash([6, 5]); ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(20, SOBEK); ctx.lineTo(KW - 20, SOBEK); ctx.stroke(); ctx.restore();
  // sobekan: DJ raksasa · label · barcode lebar · jawsel.fun
  teksMuat(ctx, d.nomor_penerjun || "DJ-????", 20, SOBEK + 86, KW - 40, 80, 900, "#141414", -3);
  teks(ctx, "NOMOR PENERJUN", 22, SOBEK + 104, f(700, 8.5), "#6b685c", "left", 1.6);
  barcode(ctx, d.nomor_penerjun || d.username, 22, SOBEK + 122, KW - 44, 52, "#141414");
  teks(ctx, "jawsel.fun", KW / 2, SOBEK + 198, f(700, 10), "#6b685c", "center", 0.4);
  // cap imigrasi menyilang garis sobekan (di atas semuanya)
  cap(ctx, d, KW - 72, SOBEK - 14);
  ctx.restore();
}

// Story 9:16 (1080×1920): langit malam navy berbintang + pendar biru, pulau low-poly di bawah, jet + payung, kartu di tengah. Tanpa teks.
export function renderStory(d) {
  const W = 1080, H = 1920, c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const langit = ctx.createLinearGradient(0, 0, 0, H); langit.addColorStop(0, "#070c22"); langit.addColorStop(0.55, "#0d1738"); langit.addColorStop(1, "#1a2a5c");
  ctx.fillStyle = langit; ctx.fillRect(0, 0, W, H);
  let s = 11; const rnd = () => { s = (s * 1103515245 + 12345) >>> 0; return (s >>> 8) / 16777216; };
  ctx.fillStyle = "#fff"; for (let i = 0; i < 220; i++) { const x = rnd() * W, y = rnd() * H * 0.75, r = 0.6 + rnd() * 1.8; ctx.globalAlpha = 0.25 + rnd() * 0.75; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill(); } ctx.globalAlpha = 1;
  // awan tipis
  ctx.fillStyle = "rgba(255,255,255,.07)"; for (const [x, y, w] of [[120, 1360, 300], [700, 1420, 360], [300, 1520, 260]]) { ctx.beginPath(); ctx.ellipse(x, y, w, 22, 0, 0, Math.PI * 2); ctx.fill(); }
  // pulau low-poly
  const py = H - 300, pts = [[150, py + 30], [330, py - 40], [560, py - 70], [800, py - 30], [960, py + 50], [880, py + 140], [640, py + 185], [380, py + 165], [190, py + 110]];
  for (const [dy, col] of [[170, "#3c2318"], [115, "#5b3a27"], [60, "#7a4f36"]]) { ctx.fillStyle = col; ctx.beginPath(); pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y + dy) : ctx.moveTo(x, y + dy)); ctx.closePath(); ctx.fill(); }
  ctx.fillStyle = "#4f9a4a"; ctx.beginPath(); pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)); ctx.closePath(); ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,.12)"; ctx.beginPath(); ctx.moveTo(330, py - 40); ctx.lineTo(560, py - 70); ctx.lineTo(640, py + 50); ctx.lineTo(400, py + 70); ctx.closePath(); ctx.fill();
  ctx.fillStyle = "rgba(0,0,0,.18)"; ctx.beginPath(); ctx.moveTo(640, py + 50); ctx.lineTo(800, py - 30); ctx.lineTo(960, py + 50); ctx.lineTo(880, py + 140); ctx.closePath(); ctx.fill();
  // jet besar kiri-atas + payung
  ctx.save(); ctx.translate(290, 250); ctx.scale(2.8, 2.8); gambarPesawat(ctx, 0, 0, 0, 1, false); ctx.restore();
  [[760, 300, "#e53935"], [860, 420, "#fdd835"], [150, 1300, d.warna || "#43a047"]].forEach(([x, y, w]) => { ctx.save(); ctx.translate(x, y); ctx.scale(2.4, 2.4); gambarPenerjun(ctx, 0, 0, 0.7, w, "", 1); ctx.restore(); });
  // kartu
  const k = 1.75; ctx.save(); ctx.translate((W - KW * k) / 2, 470); ctx.scale(k, k); gambarKartu(ctx, d); ctx.restore();
  return c;
}
